import gql from 'graphql-tag';

export const removeVideoMutation = gql`
  mutation removeVideo($videoId: String!) {
    removeVideo(videoId: $videoId)
  }
`;
